import { render, staticRenderFns } from "./AppsSwitcher.vue?vue&type=template&id=2e11c631&scoped=true&"
import script from "./AppsSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppsSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AppsSwitcher.vue?vue&type=style&index=0&id=2e11c631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e11c631",
  null
  
)

export default component.exports